import { render, staticRenderFns } from "./SelectUserField.vue?vue&type=template&id=0c4f9575"
import script from "./SelectUserField.ts?vue&type=script&lang=ts&external"
export * from "./SelectUserField.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports